<template>
  <v-table
    :count="count"
    :list="list"
    :query-list="queryList"
    :is-loading="isLoading"
    :push-list="RouteConfig.courseColumnDeletedList.push"
    :is-show-search-input="true"
    search-placeholder="输入名称进行搜索"
  >
    <v-column-time value="删除时间" field="del_time"/>
    <v-column-time sortable=""/>
    <v-column-time value="修改时间" field="update_time" sortable=""/>
    <el-table-column label="专栏 ID" width="80" prop="id"/>
    <el-table-column label="专栏名称" width="300" prop="course_column_name"/>
    <el-table-column label="专栏价格" width="300">
      <template v-slot="{ row }">
        <span>{{ row.price | toYuan }} 元</span>
      </template>
    </el-table-column>

    <el-table-column label="专栏封面" width="200">
      <template v-slot="{ row }">
        <v-img class="table-cover-video" :value="row.cover"/>
      </template>
    </el-table-column>

    <el-table-column width="210px" label="操作">
      <template v-slot="{ row }">
        <v-list-button :to="RouteConfig.courseColumnEdit.to(row.id)"/>
        <v-list-button
          name="恢复"
          icon="restore"
          @click="handleDelete(row.id)"
          :is-loading="isDeleting[row.id]"
          message="确定要恢复此专栏吗？"
          :is-last="true"
        />
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-ticket-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>删除时间</span>
              <span>{{ v.del_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>添加时间</span>
              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>修改时间</span>
              <span>{{ v.update_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>预约开始时间</span>
              <span>{{ v.start_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>预约结束时间</span>
              <span>{{ v.end_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>所属门店</span>
              <span>{{ v.store_name }}</span>
            </div>

            <div class="list-item-detail">
              <span class="flex-shrink">专栏名称</span>
              <span class="list-item-info">{{ v.course_column_name }}</span>
            </div>

            <div class="list-item-detail">
              <span>专栏封面</span>
              <v-img class="table-cover-video" :value="v.cover"/>
            </div>

            <div class="list-item-detail">
              <span>扣卡次数</span>
              <span>{{ v.decrement_number | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>通卡扣卡天数</span>
              <span>{{ v.decrement_days | toYuan }}</span>
            </div>

            <div class="list-item-detail">
              <span>预约上限</span>
              <span>{{ v.student_number }}</span>
            </div>

            <div class="list-item-detail">
              <span>已约人数</span>
              <span>{{ v.student_count }}</span>
            </div>

            <div class="list-item-button">
              <v-list-button :to="RouteConfig.courseColumnEdit.to(v.id)"/>
              <v-list-button
                name="恢复"
                icon="restore"
                @click="handleDelete(v.id)"
                :is-loading="isDeleting[v.id]"
                message="确定要恢复此专栏吗？"
                :is-last="true"
              />
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
  import RouteConfig from '@/router/config';
  import { getLegalQueryList } from '@/utils/formats';
  import { index, restore } from '@/api/course-column';

  export default {
    name: RouteConfig.courseColumnDeletedList.name,
    data: () => ({
      RouteConfig,
      isLoading: false,
      isDeleting: {},
      count: 0,
      list: [],
      queryList: {
        keyword: '',
        store_id: '',
        is_asc: 0,
        page: 1,
        size: 10,
      },
    }),
    watch: {
      '$route'(to) {
        this.load(to);
      },
    },
    beforeMount() {
      this.load();
    },
    methods: {
      async load(route = this.$route, next) {
        const { queryList } = this;
        getLegalQueryList(queryList, route.query);

        const { ...params } = queryList;
        params.is_del = 1;

        this.isLoading = true;
        const { isError, data } = await index(params);
        this.isLoading = false;
        if (isError) return;

        this.count = data.count;
        this.list = data.list;
        if (next) next();
      },
      async handleDelete(id) {
        if (!id) return this.$message.warning('缺少专栏 ID，无法恢复该专栏！');
        if (this.isDeleting[id]) return;

        this.$set(this.isDeleting, id, true);
        const { isError } = await restore(id);
        this.$set(this.isDeleting, id, false);

        if (!isError) this.load();
      },
    },
  };
</script>
